import { useMemo } from "react";
import { FeatureKey } from "@shared/schemas/feature-key.schemas";
import { EventIdPublic } from "@shared/schemas/branded-id.schemas";
import type { ThemeModeType } from "@shared/types/theme-mode.types";
import { useFeatureConfigs } from "@frontend/shared/features/feature-config/application/hooks/use-feature-configs";
import { useEventTheme } from "./useEventTheme";

export function useEventThemeFromConfig(
  eventIdPublic: string | undefined,
): void {
  const eventId = eventIdPublic ?? "";

  const { getFeatureConfig, isLoading } = useFeatureConfigs({
    context: { eventIdPublic: EventIdPublic.unsafeCreate(eventId) },
    enabled: eventId.length > 0,
  });

  const themeMode = useMemo((): ThemeModeType | undefined => {
    if (isLoading) return undefined;
    const themeConfig = getFeatureConfig(FeatureKey.EVENT_THEME);
    if (themeConfig === undefined || !themeConfig.enabled) {
      return undefined;
    }
    return themeConfig.config.themeMode;
  }, [getFeatureConfig, isLoading]);

  useEventTheme(themeMode);
}
